module.exports = __webpack_public_path__ + "static/img/28715963.5a1059a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/28715963.jpg
// module id = Cwcv
// module chunks = 0